import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { progressSelector } from '../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useModalConstructionProgressBody = (isEdit: boolean) => {
    const dispatch = useDispatch();

    const { t } = useTranslation();

    // @ts-ignore
    const { currentProgressId, albums, temporalAlbums } = useSelector(
        // @ts-ignore
        (state) => state.dashboardReducer
    );
    const progressEntities = useSelector(progressSelector.selectEntities);

    const currentProgress = progressEntities[currentProgressId];

    return { currentProgress, t, albums, temporalAlbums };
};
